// Mind2Magic CRM — Constants & Default Configuration
// Pure data only (no functions, no mutable state, no DOM access).

// ========== PIPELINE STAGES ==========
export const STAGES = [
    { id: 'nuevo', name: 'Nuevo Lead', color: '#6B4EFF' },
    { id: 'formulario', name: 'Formulario recibido', color: '#8B5CF6' },
    { id: 'no_califica', name: 'No Califica', color: '#9CA3AF' },
    { id: 'asesoria_solicitada', name: 'Asesoría solicitada', color: '#A855F7' },
    { id: 'asesoria_agendada', name: 'Asesoría agendada', color: '#D946EF' },
    { id: 'asesoria_realizada', name: 'Asesoría realizada', color: '#EC4899' },
    { id: 'proximo_ano', name: 'Próximo Año', color: '#818CF8' },
    { id: 'cotizacion_solicitada', name: 'Cotización Solicitada', color: '#FB923C' },
    { id: 'cotizacion', name: 'Cotización enviada', color: '#F97316' },
    { id: 'revision_cotizacion', name: 'Revisión Cotización', color: '#EA580C' },
    { id: 'prereserva', name: 'Pre-Reserva', color: '#EAB308' },
    { id: 'reserva_abono', name: 'Reserva con Abono', color: '#84CC16' },
    { id: 'pago_completo', name: 'Pago Completo', color: '#22C55E' },
    { id: 'documentacion', name: 'Documentación', color: '#14B8A6' },
    { id: 'en_destino', name: 'En Destino', color: '#06B6D4' },
    { id: 'finalizado', name: 'Viaje Finalizado', color: '#3B82F6' },
    { id: 'postventa', name: 'Postventa', color: '#6366F1' },
    { id: 'cancelado', name: 'Cancelado', color: '#EF4444' },
    { id: 'no_compro', name: 'No Compró', color: '#92400E' }
];

export const EMPRESAS_STAGES = [
    { id: 'pendiente', name: 'Pendiente', color: '#F97316' },
    { id: 'confirmado', name: 'Confirmado', color: '#EAB308' },
    { id: 'facturado', name: 'Facturado', color: '#84CC16' },
    { id: 'pagado', name: 'Pagado', color: '#22C55E' }
];

// ========== TRIP TYPES ==========
export const TYPE_LABELS = {
    disney: 'Disney', universal: 'Universal', disney_universal: 'Disney + Universal',
    crucero: 'Crucero', parques_crucero: 'Parques + Crucero',
    hotel: 'Hotel', evento: 'Evento', otro: 'Otro'
};

// ========== THRESHOLDS ==========
export const M2M_THRESHOLD = 700;
export const PROXIMOS_DIAS = 21;
export const MAX_HISTORY = 50;

// ========== HISTORIAL (AUDIT TRAIL) ==========
export const HISTORIAL_TIPOS = {
    etapa: { label: 'Etapa', icon: '🔄' },
    edicion: { label: 'Edición', icon: '✏️' },
    pago: { label: 'Pago', icon: '💰' },
    responsable: { label: 'Responsable', icon: '👤' },
    guia: { label: 'Itinerario', icon: '🗺️' },
    creacion: { label: 'Creación', icon: '✨' },
};

export const _HISTORIAL_FIELD_LABELS = {
    titular: 'Titular', contacto: 'Contacto', phone: 'Teléfono', email: 'Email',
    type: 'Tipo', destination: 'Destino', travelDate: 'Fecha viaje', travelEnd: 'Fecha fin',
    totalVenta: 'Valor venta', commission: 'Comisión', commission70: 'Comisión M2M',
    abono: 'Abono req.', abonado: 'Abonado', fechaAbono: 'Fecha abono', fechaPagoFinal: 'Fecha pago final',
    stage: 'Etapa', responsable: 'Responsable', reservationNum: '# Reserva',
    diasParque: 'Días parque', tipoParque: 'Tipo parque', tickets: 'Tickets',
    parkHopper: 'Park Hopper', hasDiningPlan: 'Dining Plan', hotel: 'Hotel',
    platform: 'Operador', viajeros: 'Viajeros',
    hotels: 'Hoteles', parkEntries: 'Entradas a Parques',
};

// ========== HITOS ==========
export const OPERADORES_HITOS = [
    { id: 'disney', nombre: '🏰 Disney Parks', color: '#1a1f71' },
    { id: 'disney_cruise', nombre: '🚢 Disney Cruise', color: '#0066b2' },
    { id: 'crucero', nombre: '🚢 Cruceros (MSC/Royal)', color: '#0077b6' },
    { id: 'universal', nombre: '🎢 Universal', color: '#5c2d91' },
    { id: 'hotel', nombre: '🏨 Hotel/Resort', color: '#059669' },
    { id: 'otro', nombre: '📦 Otro', color: '#6b7280' }
];

export const ICONOS_HITOS = ['🍽️', '⚡', '📱', '🚢', '🏝️', '📄', '🎢', '🌅', '🚐', '🏨', '✈️', '🎂', '💰', '📋', '🎫', '🎪'];

// ========== TYPEFORM IMPORT ==========
export const TF_TAG_MAP = {
    'Contactados': { stage: 'formulario', followUps: 0 },
    'Cotizado': { stage: 'cotizacion', followUps: 0 },
    'Cotizado,Seguimiento 1': { stage: 'cotizacion', followUps: 1 },
    'Cotizado,Seguimiento 1,Seguimiento 2': { stage: 'cotizacion', followUps: 2 },
    'Cotizado,Seguimiento 1,Seguimiento 2,Seguimiento 3': { stage: 'cotizacion', followUps: 3 },
    'Cotizado,Definiendo fechas': { stage: 'prereserva', followUps: 0 },
    'Cotizado,Retoma en diciembre': { stage: 'cotizacion', followUps: 0, note: 'Retomar en diciembre' },
    'Cotizado,Viaje pausado': { stage: 'cotizacion', followUps: 0, note: 'Viaje pausado' },
    'Reservo': { stage: 'reserva_abono', followUps: 0 },
    'No compro': { stage: 'no_compro', followUps: 0, lostReason: 'No compró' },
    'En proceso': { stage: 'reserva_abono', followUps: 0 },
    'Reservó': { stage: 'reserva_abono', followUps: 0 },
    'No Respondió': { stage: 'perdido', followUps: 0, lostReason: 'No respondió' },
    'No contesta': { stage: 'perdido', followUps: 0, lostReason: 'No contesta' },
    'No compró': { stage: 'no_compro', followUps: 0, lostReason: 'No compró' },
    'No cumple con políticas': { stage: 'perdido', followUps: 0, lostReason: 'No cumple políticas' },
    'Sin visa': { stage: 'perdido', followUps: 0, lostReason: 'Sin visa' },
    'Repetido': { stage: 'skip', followUps: 0 }
};

export const TF_STAGE_ORDER = {
    'nuevo': 1, 'formulario': 2, 'no_califica': 0, 'asesoria_solicitada': 3, 'asesoria_agendada': 4,
    'asesoria_realizada': 5, 'proximo_ano': 5.5, 'cotizacion_solicitada': 6, 'cotizacion': 7,
    'revision_cotizacion': 8, 'prereserva': 9, 'reserva_abono': 10, 'pago_completo': 11,
    'documentacion': 12, 'en_destino': 13, 'finalizado': 14, 'postventa': 15, 'no_compro': 0
};

export const TF_FORM_TYPES = {
    cruceros: { label: 'Cruceros', icon: '🚢', type: 'crucero' },
    hoteles: { label: 'Hoteles y Resorts', icon: '🏨', type: 'hotel' },
    explorando: { label: 'Explorando opciones', icon: '🌎', type: 'explorando' },
    parques: { label: 'Parques Disney & Universal', icon: '🏰', type: 'disney' }
};

// ========== FORM ANALYTICS ==========
export const FORM_TRIP_LABELS = {
    parques: 'Parques', crucero: 'Crucero', hotel: 'Hotel/Resort',
    evento: 'Evento', explorar: 'Explorando'
};

export const FORM_DEST_MAP = {
    'disney-world': 'Disney World', world: 'Disney World',
    'disneyland-ca': 'Disneyland CA', california: 'Disneyland CA',
    'disneyland-paris': 'Disneyland Paris', paris: 'Disneyland Paris',
    'tokyo-disney': 'Tokyo Disney', tokyo: 'Tokyo Disney',
    'hong-kong-disney': 'Hong Kong Disney',
    'shanghai-disney': 'Shanghai Disney',
    aulani: 'Aulani Hawaii',
    'universal-orlando': 'Universal Orlando', orlando: 'Universal Orlando',
    'universal-hollywood': 'Universal Hollywood', hollywood: 'Universal Hollywood',
    'universal-japan': 'Universal Japan', japan: 'Universal Japan',
    'universal-singapore': 'Universal Singapore', singapore: 'Universal Singapore',
    'universal-beijing': 'Universal Beijing', beijing: 'Universal Beijing'
};

export const FORM_STEP_PHASES = [
    { id: 'bienvenida', label: 'Bienvenida', steps: ['welcome'] },
    { id: 'contacto', label: 'Contacto', steps: ['nombre', 'whatsapp', 'email'] },
    { id: 'tipo_viaje', label: 'Tipo de viaje', steps: ['tipoViaje'] },
    { id: 'detalles', label: 'Detalles del viaje', steps: [
        'intereses', 'fechasFlexibles_exp', 'viajeros_exp', 'presupuesto_exp', 'recomendacion',
        'destinosCrucero', 'naviera', 'duracion', 'cabina', 'experienciaCrucero', 'puertos', 'residenciaCrucero',
        'antesDespuesCrucero', 'parquesMarca', 'disneyDestino', 'universalDestino',
        'primeraVezDisney', 'primeraVezUniversal', 'hospedaje', 'diasDisney', 'diasUniversal',
        'otrasExperiencias', 'residenteFlorida', 'residenteCalifornia', 'hotelEspecifico', 'noches', 'habitaciones',
        'eventoTipo', 'eventoEspecifico', 'eventoOtroTexto', 'eventoEquipo', 'worldCupSedes', 'worldCupFase',
        'necesitaEntradas', 'tipoEntrada', 'agregarParques',
        'destinoHotel', 'nochesHotel', 'tipoHotel', 'todoIncluidoPref'
    ]},
    { id: 'viajeros_fechas', label: 'Viajeros y fechas', steps: ['viajeros', 'fechas', 'fechasExactas', 'mesAproximadoStep', 'temporadaFlexibleStep'] },
    { id: 'extras', label: 'Presupuesto y extras', steps: ['presupuesto', 'celebracion', 'documentos', 'notas_fuente'] },
    { id: 'terminos', label: 'Términos', steps: ['terminos'] },
    { id: 'enviado', label: 'Enviado', steps: ['gracias'] },
];

// ========== DEFAULT SETTINGS ==========
export const defaultSettings = {
    // Negocio
    comisionM2M: 70,
    ventanaViaje: 10,
    responsableDefault: '',
    formatoFecha: 'mes_dia_año',
    // Abonos
    abonoDisney: 200,
    abonoUniversal: 200,
    abonoCrucero: 25,
    abonoHotel: 100,
    // Alertas
    alertaAbono: 7,
    alertaPagoFinal: 30,
    alertaViaje: 14,
    alertaWhatsApp: 2,
    autoTareaWhatsApp: true,
    // Vista
    modoCompactoDefault: true,
    ocultarValoresDefault: false,
    incluirHistoricoDefault: false,
    navZoom: 1.0,
    topZoom: 1.0,
    leadsZoom: 1.0,
    uiFontScale: 1.0,
    // Hitos por operador
    hitos: [
        { id: 'h1', operador: 'disney', nombre: 'Dining Reservations (60d)', dias: 60, icon: '🍽️', activo: true },
        { id: 'h2', operador: 'disney', nombre: 'Dining Reservations (30d)', dias: 30, icon: '🍽️', activo: true },
        { id: 'h3', operador: 'disney', nombre: 'Lightning Lane Multi Pass', dias: 7, icon: '⚡', activo: true },
        { id: 'h4', operador: 'disney', nombre: 'Lightning Lane Single Pass', dias: 3, icon: '⚡', activo: true },
        { id: 'h5', operador: 'disney', nombre: 'Check-in Online', dias: 1, icon: '📱', activo: true },
        { id: 'h6', operador: 'crucero', nombre: 'Check-in Crucero', dias: 7, icon: '🚢', activo: true },
        { id: 'h7', operador: 'crucero', nombre: 'Excursiones Disponibles', dias: 14, icon: '🏝️', activo: true },
        { id: 'h8', operador: 'crucero', nombre: 'Documentos Requeridos', dias: 30, icon: '📄', activo: true },
        { id: 'h9', operador: 'universal', nombre: 'Express Pass Planning', dias: 14, icon: '🎢', activo: true },
        { id: 'h10', operador: 'universal', nombre: 'Early Entry Info', dias: 7, icon: '🌅', activo: true },
        { id: 'h11', operador: 'hotel', nombre: 'Confirmación de Transfer', dias: 7, icon: '🚐', activo: true },
        { id: 'h12', operador: 'hotel', nombre: 'Check-in Online', dias: 1, icon: '🏨', activo: true },
        { id: 'h13', operador: 'disney_cruise', nombre: 'Excursiones en Puerto DCL', dias: 75, icon: '🏝️', activo: true },
        { id: 'h14', operador: 'disney_cruise', nombre: 'Check-in Online DCL', dias: 30, icon: '📱', activo: true },
        { id: 'h15', operador: 'disney_cruise', nombre: 'Dining Reservations DCL', dias: 30, icon: '🍽️', activo: true },
        { id: 'h16', operador: 'disney_cruise', nombre: 'Actividades a Bordo DCL', dias: 14, icon: '🎪', activo: true }
    ],
    // Plantillas de mensajes con variaciones
    plantillas: {
        viaje_inicio: [
            "Hola {nombre}! ✈️\n\n¡Tu viaje a {destino} comienza en {dias_para} días! Espero que estés muy emocionado/a.\n\n¿Tienes todo listo? Si necesitas algo, aquí estoy.\n\nSaludos,\nMind2Magic 🪄",
            "¡{nombre}! 🎉\n\nYa casi es hora de tu aventura a {destino}. Faltan solo {dias_para} días!\n\nRecuerda revisar tu documentación y hacer check-in si aún no lo has hecho.\n\n¡Que lo disfrutes mucho!",
            "Hola {nombre}, ¿cómo estás?\n\nQuería desearte un excelente viaje a {destino}. ¡Ya falta muy poco! ({dias_para} días)\n\nCualquier cosa que necesites, me escribes.\n\nBuen viaje! ✈️"
        ],
        viaje_fin: [
            "Hola {nombre}! 🏠\n\n¿Cómo estuvo tu viaje a {destino}? Espero que la hayas pasado increíble.\n\nMe encantaría saber cómo te fue. Y cuando quieras planear la próxima aventura, aquí estaré.\n\nSaludos! 🪄",
            "¡{nombre}! Bienvenido/a de vuelta 🎉\n\n¿Qué tal {destino}? Cuéntame todo!\n\nGracias por confiar en Mind2Magic para este viaje. Espero verte pronto para la próxima aventura.",
            "Hola {nombre}!\n\nEspero que hayas disfrutado muchísimo tu viaje a {destino}. 🌟\n\nSi tienes fotos o historias que compartir, me encantaría verlas. Y no olvides que para tu próximo viaje, aquí estamos.\n\n¡Saludos!"
        ],
        pago_abono: [
            "Hola {nombre}! 💰\n\nTe escribo para recordarte que el abono de tu viaje a {destino} vence en {dias_para} días.\n\nMonto pendiente: ${monto} USD\n\n¿Necesitas que te envíe los datos de pago?\n\nQuedo atenta!",
            "¡{nombre}! 👋\n\nUn recordatorio amigable: el abono para tu viaje a {destino} está próximo a vencer ({dias_para} días).\n\nSi ya realizaste el pago, me avisas para actualizar tu reserva. Si tienes alguna duda, con gusto te ayudo.\n\nSaludos!",
            "Hola {nombre}, ¿cómo estás?\n\nPasaba por aquí para recordarte sobre el abono de ${monto} USD para tu viaje a {destino}.\n\nLa fecha límite es en {dias_para} días. ¿Todo bien con eso?\n\nQuedo pendiente! 💫"
        ],
        pago_final: [
            "Hola {nombre}! 💰\n\nSe acerca la fecha de pago final para tu viaje a {destino} (en {dias_para} días).\n\nSaldo pendiente: ${monto} USD\n\nUna vez completado el pago, te enviaré toda la documentación. ¿Alguna pregunta?\n\nSaludos!",
            "¡{nombre}! 📋\n\nRecordatorio importante: el pago final de tu viaje vence en {dias_para} días.\n\nDestino: {destino}\nMonto: ${monto} USD\n\n¿Necesitas los datos bancarios o tienes alguna duda?\n\nQuedo atenta!",
            "Hola {nombre}!\n\nTu viaje a {destino} está cada vez más cerca 🎉 Solo falta completar el pago final (${monto} USD) antes de {dias_para} días.\n\nAvísame cuando lo realices para confirmar todo.\n\n¡Saludos!"
        ],
        cumpleanos: [
            "🎂 ¡Feliz cumpleaños {nombre}! 🎉\n\nQue este nuevo año de vida esté lleno de aventuras y viajes increíbles.\n\n¡Un abrazo grande de parte de Mind2Magic! 🪄",
            "¡{nombre}! 🎈🎂\n\n¡Muchas felicidades en tu día! Que la pases rodeado/a de las personas que más quieres.\n\nY cuando estés listo/a para celebrar con un viaje, aquí estaré.\n\n¡Feliz cumpleaños!",
            "Hola {nombre}! 🎉\n\n¡Feliz cumpleaños! Espero que hoy sea un día muy especial para ti.\n\nQue este nuevo año te traiga muchas aventuras y destinos por descubrir. 🌍✨\n\n¡Un abrazo!"
        ],
        hito_disney: [
            "Hola {nombre}! 🏰\n\n¡Recordatorio mágico! En {dias_para} días es momento de {hito} para tu viaje a Disney.\n\n¿Necesitas ayuda con las reservaciones? Con gusto te asesoro para conseguir los mejores horarios.\n\n¡Saludos mágicos! ✨",
            "¡{nombre}! ⚡\n\nSe acerca una fecha importante para tu viaje Disney: {hito} ({dias_para} días).\n\nSi quieres que te ayude a planificar o tienes dudas sobre cómo funciona, me escribes.\n\n¡La magia está por comenzar! 🪄",
            "Hola {nombre}!\n\nTe escribo porque en {dias_para} días debes hacer {hito} para aprovechar al máximo tu viaje a Disney. 🏰\n\n¿Lo tienes en tu radar? Si necesitas tips o ayuda, aquí estoy.\n\n¡Saludos!"
        ],
        hito_crucero: [
            "Hola {nombre}! 🚢\n\nRecordatorio para tu crucero: en {dias_para} días es momento de {hito}.\n\n¿Tienes todo listo? Si necesitas ayuda con el proceso, me avisas.\n\n¡Buen viento y buena mar! ⚓",
            "¡{nombre}! 🌊\n\nSe acerca {hito} para tu crucero ({dias_para} días).\n\nRecuerda tener a mano tu número de reserva y documentos. Si tienes dudas, con gusto te ayudo.\n\n¡Nos vemos en alta mar! 🚢",
            "Hola {nombre}!\n\nPasando a recordarte sobre {hito} - tienes {dias_para} días para completarlo.\n\nEs importante para tu crucero. ¿Todo bien o necesitas una mano?\n\nSaludos! 🛳️"
        ],
        hito_disney_cruise: [
            "Hola {nombre}! 🚢✨\n\nRecordatorio para tu crucero Disney: en {dias_para} días es momento de {hito}.\n\n¿Necesitas ayuda? Con gusto te asesoro.\n\n¡La magia en alta mar te espera! ⚓🏰",
            "¡{nombre}! 🌊\n\nSe acerca {hito} para tu crucero Disney ({dias_para} días).\n\nRecuerda que los espacios se llenan rápido. Si quieres que te ayude, me escribes.\n\n¡Nos vemos a bordo! 🚢",
            "Hola {nombre}!\n\nTu crucero Disney se acerca y en {dias_para} días es hora de {hito}.\n\nNo lo dejes para después — las mejores opciones se van rápido.\n\n¡Saludos mágicos! ✨🛳️"
        ],
        hito_universal: [
            "Hola {nombre}! 🎢\n\nEn {dias_para} días es buen momento para {hito} de tu viaje a Universal.\n\n¿Quieres que te cuente los tips para aprovecharlo al máximo?\n\n¡Saludos!",
            "¡{nombre}! 🦖\n\nRecordatorio Universal: {hito} en {dias_para} días.\n\nSi tienes dudas sobre cómo funciona o quieres recomendaciones, me escribes.\n\n¡A disfrutar las atracciones! 🎢",
            "Hola {nombre}!\n\nSe viene {hito} para tu viaje a Universal ({dias_para} días).\n\nCuéntame si necesitas ayuda con la planificación.\n\n¡Saludos!"
        ],
        hito_general: [
            "Hola {nombre}! 📋\n\nRecordatorio: en {dias_para} días es momento de {hito} para tu viaje a {destino}.\n\n¿Todo listo? Si tienes preguntas, aquí estoy.\n\nSaludos!",
            "¡{nombre}! 👋\n\nPasando a recordarte sobre {hito} ({dias_para} días).\n\nEs importante para tu viaje a {destino}. ¿Necesitas ayuda?\n\n¡Saludos!",
            "Hola {nombre}!\n\nTe escribo para recordarte: {hito} está próximo ({dias_para} días).\n\nDestino: {destino}\n\nCualquier duda, me avisas.\n\n¡Saludos!"
        ]
    }
};
